<template>
  <div class="guides">
    <div class="guides-head">
      <span>Группа</span>
      <el-input
        style="width: 200px; margin: 0 15px;"
        placeholder="Введите группу"
        v-model="group"
      />
      <el-button @click="loadReferences()" type="primary">Загрузить</el-button>
    </div>
    <div class="guides-list">
      <div v-for="reference of referencesList" :key="reference.id" class="guides-list-item">
        <div class="guides-list-item-head">
          <h3 class="guides-list-item-title">{{reference.title}}</h3>
          <el-button type="primary" size="small" @click="addItemHandler(reference.id)">Добавить</el-button>
        </div>
        <div class="guides-references-list">
          <reference-item
            v-for="item of reference.items"
            :key="item.id"
            :reference-item="item"
            :active-edit-item-id="activeEditItemId"
            @onEditItem="editItemHandler"
            @onDeleteItem="deleteItemHandler"
            @onCancelEditItem="cancelEditItemHandler"
          />
        </div>
      </div>
    </div>

    <el-dialog title="Создание записи" :visible.sync="createDialogVisible">
      <div class="guides-modal">
        <div class="guides-modal-row">
          <label>
            <span>Название</span>
            <el-input v-model="newReferenceName" autocomplete="off"></el-input>
          </label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button>Отмена</el-button>
        <el-button type="primary" @click="saveReferencesItem()">Сохранить</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // components
  import ReferenceItem from "./components/ReferenceItem.vue"

  // api
  import { getReferencesApi, getReferenceAddItemApi, getReferenceRemoveItemApi } from "../../../../../api/references";

  // vuex
  import { mapGetters } from "vuex";

  export default {
    name: 'Guides',
    data() {
      return {
        group: '',
        referencesList: [],
        currentReferenceId: null,
        createDialogVisible: false,
        newReferenceName: '',
        newReferenceKeyword: '',
        newReferenceKeywordList: [],
        activeEditItemId: null,
        roles: this.$t('user.roles'),
      };
    },
    computed: {
      ...mapGetters([
        "users",
        "isAdmin",
      ]),
    },
    methods: {
      getRole(role) {
        return this.roles.find(item => item.name === role).title;
      },
      loadReferences() {
        if (this.group !== '') {
          const params = {
            group_id: parseInt(this.group)
          }
          getReferencesApi(params).then((resp) => {
            this.referencesList = resp.data;
          });
        }
      },
      addItemHandler(id) {
        this.currentReferenceId = id;
        this.createDialogVisible = true;
      },
      editItemHandler(id) {
        this.activeEditItemId = id;
      },
      cancelEditItemHandler() {
        this.activeEditItemId = null;
      },
      deleteItemHandler(id) {
        getReferenceRemoveItemApi({ item_id: id}).then(() => {
          this.loadReferences();
        })
      },
      saveReferencesItem() {
        if (!this.currentReferenceId && this.newReferenceName === '') {
          return
        }

        const params = {
          reference_id: this.currentReferenceId,
          keyword: this.newReferenceName,
          group_id: parseInt(this.group)
        }
        getReferenceAddItemApi(params).then(() => {
          this.currentReferenceId = null;
          this.newReferenceName = '';
          this.createDialogVisible = false;
          this.loadReferences();
        })
      }
    },
    components: {
      ReferenceItem
    }
  };
</script>

<style>
  .guides-head {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .guides-list {}
  .guides-list-item:not(:last-child) {
    margin-bottom: 40px;
  }
  .guides-list-item-head {
    display: flex;
    align-items: center;
    margin: 0 0 15px;
  }
  .guides-list-item-head .el-button--small, .el-button--small.is-round {
    padding: 4px 15px;
  }
  .guides-list-item-title {
    margin: 0 20px 0 0;
  }
  .guides-references-list {}
  .guides-references-list-item {}
  .guides-modal-row {}
  .guides-modal-row span {
    display: block;
    margin-bottom: 5px;
  }
</style>